import { useState, useEffect } from "react";
import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import './index.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';

const AddReasonCodeModal = ({ openAddReasonCodesModal, handleCloseAddReasonCodesModal, handleSubmitAddReasonCodesModal, isEditMode, editModeData, handleUpdateEditDetailsModal, rowData, nextReasonCode }) => {
    const [disableAddApprovalButton, setDisableAddApprovalButton] = useState(true);

    const getNextReasonCode = () => {
        const allCodes = [
            ...(rowData || []),
            ...(rows || [])
        ].map(item => Number(item.reasonCode));

        if (allCodes.length === 0) return 1;

        return Math.max(...allCodes) + 1;
    };

    const initialData = [
        {
            reasonCode: nextReasonCode,
            description: '',
            active: true,
            rowKey: Date.now()
        }
    ];

    const [rows, setRows] = useState(initialData);
    const [key, setKey] = useState(0);

    useEffect(() => {
        if (openAddReasonCodesModal) {

            if (isEditMode && editModeData) {
                // ✅ EDIT MODE → show existing values
                setRows([
                    {
                        reasonCode: editModeData.reasonCode,
                        description: editModeData.description,
                        active: true,
                        rowKey: Date.now()
                    }
                ]);
            } else {
                // ✅ ADD MODE → auto next number
                setRows(initialData);
            }
        }
    }, [isEditMode, editModeData, openAddReasonCodesModal, nextReasonCode]);

    const handleChangeReasonCode = (index, value) => {
        setRows(prevRows =>
            prevRows.map((row, i) =>
                i === index
                    ? { ...row, reasonCode: value }
                    : row
            )
        );
    };

    const handleReasonCodes = () => {
        const nextCode = getNextReasonCode(); // auto next number
        setRows(prevRows => [
            ...prevRows,
            {
                reasonCode: nextCode,
                description: "",
                active: true,
                rowKey: `${Date.now()}_${Math.random().toString(36).slice(2)}`
            }
        ]);
        setDisableAddApprovalButton(true);
    };

    const isRowValid = (row) => {
        return !!row.reasonCode && !!row.description?.trim();
    };

    const allNamesFilled = rows.length > 0 && rows.every(isRowValid);

    const handleDeleteRow = (index) => {
        const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
        // Reassign levels
        const updatedRows = newRows.map((row, rowIndex) => ({
            ...row,
            level: rowIndex + 1
        }));
        setRows(updatedRows);
        // setKey(prevKey => prevKey + 1);
    };

    const getUniqueValues = (data = []) => {
        if (data?.length > 0) {
            const unique = [];
            const map = new Set();

            data.forEach(p => {
                if (!map.has(p.plant)) {
                    map.add(p.plant);
                    unique.push(p);
                }
            });
            return unique?.map(value => ({ label: `${value.plant} | ${value.plantName}`, value: value.plant, title: `${value.plant} | ${value.plantName}` }))
        }
        else {
            return []
        }
    };

    const handleChangeDescription = (index, value) => {
        setRows(prevRows =>
            prevRows.map((row, i) =>
                i === index
                    ? { ...row, description: value }
                    : row
            )
        );
    };



    const handleClearAll = () => {
        setRows(initialData);
        setKey(prevKey => prevKey + 1);
    };

    const onCloseInviteSupplierModal = () => {
        handleCloseAddReasonCodesModal();
        handleClearAll();
    }

    const onClickCancel = () => {
        handleClearAll();
        handleCloseAddReasonCodesModal();
    }

    const onClickSubmit = () => {
        handleClearAll();
        handleSubmitAddReasonCodesModal(rows);
    }

    const onClickUpdateDetails = () => {
        handleUpdateEditDetailsModal(rows);
    }

    return (
        <div>
            <Modal
                className="InviteUserModal_cls"
                open={openAddReasonCodesModal}
                handleClose={onCloseInviteSupplierModal}
                title={isEditMode === false && openAddReasonCodesModal ? "Add Reason Code" : isEditMode === true && openAddReasonCodesModal ? "Edit Reason Code" : ""}
                fullWidth={true}
                maxWidth={"md"}
                action={
                    <AddReasonCodeModalFooter
                        onClickCancel={onClickCancel}
                        onClickSubmit={onClickSubmit}
                        handleClearAll={handleClearAll}
                        allNamesFilled={allNamesFilled}
                        openAddReasonCodesModal={openAddReasonCodesModal}
                        isEditMode={isEditMode}
                        onClickUpdateDetails={onClickUpdateDetails}

                    />
                }
                content={
                    <AddReasonCodeModalContent
                        key={key}
                        disableAddApprovalButton={disableAddApprovalButton}
                        handleReasonCodes={handleReasonCodes}
                        getUniqueValues={getUniqueValues}
                        handleChangeDescription={handleChangeDescription}
                        handleChangeReasonCode={handleChangeReasonCode}
                        rows={rows}
                        allNamesFilled={allNamesFilled}
                        onHandleDeleteIcon={handleDeleteRow}
                        isEditMode={isEditMode}
                        openAddReasonCodesModal={openAddReasonCodesModal}
                        editModeData={editModeData}
                    />
                }
            />
        </div>
    )
}
const AddReasonCodeModalFooter = ({ onClickCancel, onClickSubmit, handleClearAll, allNamesFilled, openAddReasonCodesModal, isEditMode, onClickUpdateDetails

}) => {
    return (
        <div className='btn-wrapper_inviteUser' style={{ display: 'flex', gap: 10 }}>
            <ButtonComponent
                label="Back"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                maxWidth="170px"
                label={"Clear All"}
                type="primary"
                onClick={handleClearAll}
            />
            {(isEditMode === true && openAddReasonCodesModal) ?
                <ButtonComponent
                    label="Update"
                    type="secondary"
                    maxWidth="100px"
                    onClick={onClickUpdateDetails}
                    disabled={!allNamesFilled}
                />
                : <ButtonComponent
                    label="Save"
                    type="secondary"
                    maxWidth="100px"
                    onClick={onClickSubmit}
                    disabled={!allNamesFilled}
                />}
        </div>
    );
};
const AddReasonCodeModalContent = ({ allNamesFilled, rows, handleChangeDescription, handleReasonCodes, onHandleDeleteIcon, isEditMode, openAddReasonCodesModal, handleChangeReasonCode }) => {
    return (
        <div>
            <div className='approval-wrapper'>
                {rows?.map((item, index) => (
                    <div className='sendForApprover-container' key={item.rowKey}>
                        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>

                            <div style={{ width: 50 }}>
                                {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}>Code</div>}
                                <TextField
                                    value={item.reasonCode || ""}
                                    disabled   // optional: lock in edit mode
                                    onChange={(e) =>
                                        handleChangeReasonCode(index, e.target.value)
                                    }
                                    sx={{
                                        height: 40,
                                        // width: 120,
                                        "& .MuiInputBase-root": {
                                            height: 40,
                                        },
                                    }}
                                />

                            </div>


                            <div style={{ flex: 1 }}>
                                {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}>Reason Name</div>}
                                <TextField
                                    placeholder="Enter Reason Name"
                                    value={item.description || ""}
                                    onChange={(e) =>
                                        handleChangeDescription(index, e.target.value)
                                    }
                                    InputLabelProps={{ shrink: false }}
                                    sx={{
                                        height: 40,
                                        maxWidth: 400,
                                        "& .MuiInputBase-root": {
                                            height: 40,
                                            width: 700
                                        },
                                    }}
                                />
                            </div>

                            {!isEditMode && <div className='deleteIcon-column' style={{ textAlign: "right" }}>
                                {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}><p></p></div>}
                                <IconButton style={{ marginTop: index === 0 ? 10 : 0, }}>
                                    {rows.length !== 1 && <DeleteIcon onClick={() => onHandleDeleteIcon(index)} />}
                                </IconButton>
                            </div>}
                        </div>
                    </div>
                ))}
            </div>
            {isEditMode === false && openAddReasonCodesModal && <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '40px', marginTop: "15px" }}>
                <ButtonComponent
                    maxWidth="170px"
                    label="Add Reason Code"
                    type="primary"
                    disabled={!allNamesFilled}
                    onClick={handleReasonCodes}
                />
            </div>}
        </div>
    );
};

export default AddReasonCodeModal;